import React from 'react';
import PropTypes from 'prop-types';
import ReactHtmlParser from 'components/UI/HtmlParser';
import { withFormHandler } from '../FormComponent';

function Checkbox({
    onChange, error, disabled, printErrors, value, path, styles, containerClassName, errorClassName, text, className,
})
{
    const handleChange = (e) =>
    {
        if (onChange) onChange(e.target.checked, path);
    };

    const errorContent = error && printErrors ? <span className={`${errorClassName} tw-text-sm tw-text-red-600 dark:tw-text-[#FF565D] tw-ml-2`}>{ReactHtmlParser(error)}</span> : null;

    return (
        <div className={containerClassName}>
            <button
                type="button"
                onClick={() =>
                {
                    if (onChange) onChange(!value, path);
                }}
            >
                <label className="tw-text-neutral-darkest tw-font-bold tw-text-sm">
                    {text}
                </label>
            </button>

            <input
                className={`${className || 'tw-ml-3'} `}
                style={{
                    ...{
                        transition: 'all 0.1s ease', width: '20px', height: '20px', accentColor: 'rgb(var(--ujv-color-button-primary-text-dark))',
                    },
                    ...styles,
                }}
                type="checkbox"
                value={value || false}
                checked={value || false}
                disabled={disabled}
                onChange={handleChange}
            />
            {errorContent}
        </div>
    );
}

Checkbox.defaultProps = {
    disabled: false,
    error: '',
    printErrors: true,
    text: '',
};

Checkbox.propTypes = {
    onChange: PropTypes.func,
    error: PropTypes.node,
    disabled: PropTypes.bool,
    printErrors: PropTypes.bool,
    value: PropTypes.any,
    path: PropTypes.string,
    styles: PropTypes.any,
    containerClassName: PropTypes.string,
    errorClassName: PropTypes.string,
    text: PropTypes.string,
    className: PropTypes.string,
};

export default withFormHandler(Checkbox);
